import type { IMBEStore } from '@/types';
import { useEffect, useState } from 'react';
import { useStoresApi } from '../api';

interface IUseCouponStoreReturnValue {
  loading: boolean;
  store?: IMBEStore;
}

export const useCouponStore = (coupon?: string): IUseCouponStoreReturnValue => {
  const storesApi = useStoresApi();
  const [store, setStore] = useState<IMBEStore | undefined>();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (coupon) {
      setLoading(true);

      const fetch = async (): Promise<void> => {
        try {
          const data = await storesApi.getStoreByCouponCode(coupon);
          setStore(data[0]);
        } catch {
          // eslint-disable-next-line unicorn/no-useless-undefined
          setStore(undefined);
        } finally {
          setLoading(false);
        }
      };

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      fetch();
    }
  }, [coupon, storesApi]);

  return { loading: isLoading, store };
};
